import React, { useEffect, useState } from "react";
import { Col, Row } from "antd";
import styled from "styled-components";
import { useContentful } from "react-contentful";
import { Link } from "react-router-dom";
import dayjs from "dayjs";
import relativeTime from "dayjs/plugin/relativeTime";
import { list } from "src/data/career/listLocation";

dayjs.extend(relativeTime);

const TitleText = styled.h3`
  color: white;
  font-size: 18px;
  cursor: pointer;
  @media screen and (max-width: 500px) {
    font-size: 12px;
  }
`;

const Text = styled.p`
  font-size: 14px;
  color: white;
  text-align: center;
  @media screen and (max-width: 500px) {
    font-size: 10px;
  }
`;

const Show = styled.div`
  text-align: center;
  margin: 40px 0;
`;

const ButtonShowMore = styled.button`
  padding: 10px 20px;
  background-color: #4c98ff;
  border-radius: 20px;
  color: white;
  font-size: 20px;
  outline: none;
  border: none;
  cursor: pointer;
`;

type Fields = {
  content: {};
  date: string;
  location: string;
  title: string;
  workType: string;
};

type Data = {
  items: Array<{ fields: Fields; sys: { id: string } }>;
} | null;

// @ts-ignore
const Search = (props) => {
  //const [entities, setEntities] = useState<Data>(null);
  // const { data, error, fetched, loading } = useContentful({
  //   contentType: "hrPost",
  // });

  // useEffect(() => {
  //   // @ts-ignore
  //   return setEntities(data);
  // }, [data]);

  return (
    <section className="container" style={{ marginTop: "10%" }}>
      {list?.map((v, i) => {
        return (
          <Row
            justify="space-around"
            wrap={true}
            key={i}
            style={{
              borderBottom: "1px solid #dcd5d5",
              padding: "0px 0 15px",
            }}
          >
            <Col xs={6}>
              <Link to={`/career/${v.id}`}>
                <TitleText>{v.title}</TitleText>
              </Link>
              <Text style={{ textAlign: "left" }}>
                {dayjs(v.date).fromNow()}
              </Text>
            </Col>
            <Col xs={12} style={{ alignContent: "end" }}>
              <Text>{v.area}</Text>
            </Col>
            <Col xs={6} style={{ alignContent: "end" }}>
              <Text style={{ textAlign: "right" }}>{v.position}</Text>
            </Col>
          </Row>
        );
      })}
    </section>
  );
};

export default Search;
